<template>
  <div class="avatar-popup-menu">
    <v-list two-line dense class="">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img :alt="item && item.user && item.user.avatar ? item.user.avatar : 'default-avatar.gif'" :src="item && item.user && item.user.avatar ? item.user.avatar : require('@/assets/images/default-avatar.gif')">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title :style="{color: styles.general.theme_color_dark}" style="font-size:15px;font-weight:900;text-transform:capitalize;">{{
            item.user.firstname + ' ' + item.user.lastname}}</v-list-tile-title>
          <v-list-tile-sub-title>
            <div style="color:#000;font-size:15px;">{{ item.user.jobtitle }} <span v-if="item.user.jobtitle && item.company">|
                {{ item.company.companylegalname }}</span></div>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div class="avatar-popup-action">
      <v-btn @click="openChat(uid)" color="primary">Message</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['targetElement', 'item', 'uid'],
  data () {
    return {
      positionStyle: {}
    }
  },
  computed: {
    styles () {
      return this.$store.getters.getStyles
    }
  },
  methods: {
    openChat (uid) {
      window.$applozic.fn.applozic('loadTab', uid)
      $('html').addClass('sidebox-open')
    }
  }
}
</script>

<style>
.avatar-popup-menu .avatar-popup-action {
  background: #fff;
  padding: 0 10px 10px 10px;
}
.avatar-popup-menu .avatar-popup-action .btn {
  margin: 0;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// AvatarPopup.vue?2234846e